import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()

export class GenerarPolizaService {

  constructor(private http: HttpClient) {}

  // OBTENER PERIODO CONTABLE
  public getPeriodo(): Observable<any> {
    return this.http.post('api/control-cartera/operacion/generar-poliza/pc/get', {}).pipe(
      map(res => {
        return JSON.parse(JSON.stringify(res));
      })
    );
  }

  // OBTENER TIPO POLIZA
  public getTipoPo(): Observable<any> {
    return this.http.post('api/control-cartera/operacion/generar-poliza/pci/get', {}).pipe(
      map(res => {
        return JSON.parse(JSON.stringify(res));
      })
    );
  }
  
  // ENVIAR DATOS PARA GENERAR POLIZA
  public PostGenerarPoliza(datos: any): Observable<any> {
    return this.http.post('api/control-cartera/operacion/generar-poliza/pcg/get', datos).pipe(
      map(res => {
        return JSON.parse(JSON.stringify(res));
      })
    );
  }
}


